import { PurchaseOrder } from './purchaseOrder';
import { User } from './user';

export enum WorkOrderStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

export interface WorkOrderItem {
  id: number;
  productId: number;
  productName: string;
  quantity: number;
  completedQuantity: number;
}

export interface WorkOrderScan {
  id: number;
  workOrderId: number;
  userId: number;
  user: User;
  scanType: 'IN' | 'OUT' | 'PROGRESS';
  timestamp: string;
  notes?: string;
}

export interface WorkOrder {
  id: number;
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: number;
  status: WorkOrderStatus;
  createdAt: string;
  updatedAt: string;
  startedAt?: string;
  completedAt?: string;
  assignedTo?: User;
  assignedToId?: number;
  items: WorkOrderItem[];
  scans: WorkOrderScan[];
  notes?: string;
  priority: 'LOW' | 'MEDIUM' | 'HIGH';
  estimatedCompletionDate?: string;
  actualCompletionDate?: string;
  qualityCheckStatus?: 'PENDING' | 'PASSED' | 'FAILED';
  qualityCheckNotes?: string;
}